import {MessageUtilsService} from "./message-utils.service";
import {ConfirmationService, MessageService} from "primeng/api";
import {TranslocoService} from "@jsverse/transloco";
import {combineLatest, from, map, Observable, Observer, take} from "rxjs";
import {SelectOption} from "../../../core/models/entities";
import {switchMap} from "rxjs/operators";
import {CurrentUserService} from "../current-user.service";
import dayjs from "dayjs";


export class SharedUtils {
  private static _instance: SharedUtils;

  static instance(): SharedUtils {
    // if (!this._instance) {
    //   this._instance = inject(SharedUtils); // Usa inject() per ottenere il servizio singleton
    // }
    return this._instance;
  }

  static setInstance(messageService: MessageService, confirmationService: ConfirmationService, translateService: TranslocoService, currentUserService: CurrentUserService) {
    if( !this._instance ) {
      this._instance = new SharedUtils(new MessageUtilsService(messageService, translateService), confirmationService, translateService, currentUserService);
    }
  }

  private constructor(private messageUtilsService: MessageUtilsService, public confirmationService: ConfirmationService, private translateService: TranslocoService, private currentUserService: CurrentUserService) {}

  public currentUser(): CurrentUserService {
    return this.currentUserService;
  }

  public messageUtils(): MessageUtilsService {
    return this.messageUtilsService;
  }

  //FIXME potremmo farlo meglio intanto va bene
  public confirm(event?: Event, message?: string) {

    message = message || 'confirm.default.message';

    return new Observable
    ((observer: Observer<boolean>) => {
      this.confirmationService.confirm({
        target: event?.target as EventTarget,
        message: this.translateService.translate(message),
        header: this.translateService.translate('confirm.default.header'),
        icon: 'pi pi-info-circle',
        acceptButtonStyleClass: "p-button-danger p-button-text",
        rejectButtonStyleClass: "p-button-text p-button-text",
        acceptIcon: "none",
        rejectIcon: "none",
        acceptLabel: this.translateService.translate('confirm.default.acceptLabel'),
        rejectLabel: this.translateService.translate('confirm.default.rejectLabel'),
        accept: () => {
          console.log('accepted')
          observer.next(true);
          observer.complete();
        },
        reject: () => {
          console.log('rejected');
          observer.next(false);
          observer.complete();
        }
      });
    })

  }

  public translate(key:string): Observable<readonly unknown[]> {
    return from(this.translateService.load(this.translateService.getActiveLang())).pipe(
      take(1), // aspetta che la traduzione corrente sia pronta
      switchMap(() => this.translateService.selectTranslate(key))
    );
  }

  public translateOptions(options: string[], base: string): Observable<SelectOption[]> {
    return from(this.translateService.load(this.translateService.getActiveLang())).pipe(
      take(1), // aspetta che la traduzione corrente sia pronta
      switchMap(() =>
        combineLatest(
          options.map(o =>
            this.translateService.selectTranslate(`${base}.${o}`).pipe(
              map(description => ({ value: o, description }))
            )
          )
        )
      )
    );
  }
  // public translateOptions(options: string[], translateBase: string): Observable<SelectOption[]> {
  //
  //   return combineLatest(
  //     options.map(o =>
  //       this.translateService.selectTranslate(`${translateBase}.${o}`).pipe(
  //         map(description => ({ value: o, description }))
  //       )
  //     )
  //   );
  // }

  //da date a 'yyyy-MM-dd'
  toIsoDateString(date: any): String {
    return dayjs(date).format('YYYY-MM-DD')
  }

  //da 'yyyy-MM-dd' a js Date
  fromIsoDate(value: any): Date{
    return dayjs(value).startOf('day').toDate()
  }

  fromIsoDateTime(value: any): Date{
    return dayjs(value).toDate()
  }



}
